import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;

export const Card = styled.li`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid white;
  padding: 0 10rem;

  @media (max-width: 768px) {
    padding: 0 2rem;
  }
`;

export const RowContent = styled.div`
  padding-top: 4rem;
  padding-bottom: 1.5rem;

  color: white;

  font-size: 1.8rem;

  display: flex;
  justify-content: space-between;

  p {
    text-transform: capitalize;
  }

  @media (max-width: 425px) {
    padding: 0 2rem;
    padding-top: 4rem;
    padding-bottom: 1.5rem;
  }
`;

export const RowButtons = styled.div`
  width: 10rem;

  svg {
    cursor: pointer;

    :first-child {
      margin-right: 3rem;
    }
  }
`;

export const DeleteContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    margin-bottom: 3rem;
    text-transform: uppercase;
  }

  p {
    width: 80%;
    font-size: 1.8rem;
    text-align: center;
    margin-bottom: 6rem;
  }

  div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    button {
      width: 10rem;
      height: 4rem;
      background: transparent linear-gradient(96deg, #000000 0%, #232323 100%)
        0% 0% no-repeat padding-box;
      border-radius: 50px;
      opacity: 1;

      color: #fff;
      font-weight: bold;

      transition: 0.2s;

      &:hover {
        filter: brightness(0.9);
      }
    }
  }
`;

export const EditContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 5rem 3rem;

  h1 {
    padding-bottom: 2rem;
  }

  form {
    width: 60%;
    margin-bottom: 2rem;
  }

  button {
    width: 60%;
    height: 5rem;
  }
`;

export const NoData = styled.div`
  color: white;
  margin-top: 10%;
  width: 100%;
  text-align: center;
  font-size: 2rem;
`;
